var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import FileSvg from './file.icon.svg';
export const FileIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: FileSvg }));
_react_refresh_temp_1 = FileIcon;
$RefreshReg$(_react_refresh_temp_1, "FileIcon");
